import {Injectable} from '@angular/core';
import {ApiService} from './api/api.service';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class AzureService {
    constructor(private apiService: ApiService) {
    }

    getOpenPullRequests(project?: string): Observable<any> {
        const params = project ? {project} : {};
        return this.apiService.getCallData$<AzureProjectPR[]>('azure/pullrequests', params);
    }

    getWeeklyPullRequests(year: number, week: number, email?: string): Observable<any> {
        return this.apiService.getCallData$<{ project: string; prs: AzureWeeklyPullRequest[] }[]>('azure/pullrequests/week', {year, week, email});
    }

    getOpenTasks() {
        return this.apiService.getCallData$<AzureTask[]>('azure/opentasks', {});
    }

    getQueryLinks() {
        return this.apiService.getCallData$<QueryLinks[]>('azure/querylinks');
    }

    sortTasks(taskIds: number[]): Observable<any> {
        return this.apiService.postCall$('azure/tasks/sort', {task_ids: taskIds});
    }
}

export interface AzureProjectPR {
    project: string;
    prs: AzurePullRequest[];
    error?: string;
}

export interface AzurePullRequest {
    repository: {
        id: string;
        name: string;
        url: string;
        project: {
            id: string;
            name: string;
            state: string;
            visibility: string;
            lastUpdateTime: string;
        };
    };
    pullRequestId: number;
    codeReviewId: number;
    status: string;
    createdBy: AzureUser;
    creationDate: string;
    title: string;
    description: string;
    sourceRefName: string;
    targetRefName: string;
    mergeStatus: string;
    isDraft: boolean;
    mergeId: string;
    reviewers: AzureReviewer[];
    url: string;
    supportsIterations: boolean;
    workItems?: AzureWorkItem[];
}

export interface AzureWeeklyPullRequest {
    project: string;
    repository: string;
    pullRequestId: number;
    status: string;
    createdBy: {
        displayName: string;
        email: string;
    };
    creationDate: string;
    closedDate: string | null;
    title: string;
    sourceRefName: string;
    targetRefName: string;
    url: string;
    reviewers: AzureReviewer[];
    workItems: AzureWorkItem[];
}

export interface AzureReviewer {
    id: string;
    displayName: string;
    imageUrl: string;
    vote: number;
    _links?: {
        avatar: {
            href: string;
        };
    };
}

export interface AzureUser {
    displayName: string;
    url: string;
    _links: {
        avatar: {
            href: string;
        };
    };
    id: string;
    uniqueName: string;
    imageUrl: string;
    descriptor: string;
}

export interface AzureWorkItem {
    id: number;
    title: string;
    workItemType: string;
    state: string;
}

export interface AzureTaskAssignedTo {
    displayName: string;
    email: string;
}

export interface AzureTask {
    id: number;
    title: string;
    parent_title: string;
    parent_id: number;
    parent_workItemType: string;
    grandparent_title: string;
    grandparent_id: number;
    grandparent_workItemType: string;
    state: string;
    project: string;
    project_id: string;
    workItemType: string;
    severity: string;
    assignedTo: AzureTaskAssignedTo | null;
    changed_by: string;
    changed_date: string;
    url: string | null;
    relatedPRs?: { project: string; pr: AzurePullRequest }[];
}

export interface QueryLinks {
    id: string;
    name: string;
    url: string;
    icon?: string;
}
